module.exports = __webpack_public_path__ + "static/media/LD.f419bc74.webp";